import { useEffect } from 'react';
import { PermissionEnum } from '@ui/src';

import { useAppSelector } from '@store';
import {
  useLazyGetDeliveryChannelValidatorsQuery,
  useLazyGetIndividualDeliveryChannelsQuery,
} from '../store/services';
import { RiskScoreClientTypeEnum } from '../../types';
import DeliveryChannelsList from '../../partial/delivery-channels/list';

const IndividualDeliveryChannels = (): React.JSX.Element => {
  const [getValidators] = useLazyGetDeliveryChannelValidatorsQuery();

  const {
    amlDictionaries: { activePermissions },
    individualClientsRisk: {
      deliveryChannels: {
        list: { values, pagination },
      },
    },
  } = useAppSelector((state) => state);

  const [getIndividualDeliveryChannels, { isLoading, isFetching }] =
    useLazyGetIndividualDeliveryChannelsQuery();

  useEffect(() => {
    if (
      activePermissions?.includes(
        PermissionEnum.SETTINGS_DELIVERY_CHANNELS_LIST,
      )
    ) {
      getValidators();
    }
  }, [activePermissions]);

  useEffect(() => {
    let title = 'Individual Delivery channels';

    const companyName = localStorage.getItem('companyName');

    if (companyName) {
      title = `${title} | ${companyName}`;
    }

    document.title = title;
  }, []);

  return (
    <DeliveryChannelsList
      values={values}
      pagination={pagination}
      getList={getIndividualDeliveryChannels}
      isFetching={isFetching}
      clientType={RiskScoreClientTypeEnum.INDIVIDUAL}
      isLoading={isLoading}
    />
  );
};

export default IndividualDeliveryChannels;
